// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F5QZ","inner":"styles_inner__1WTer","right":"styles_right__1Gy5N","close":"styles_close__33Dm0","footer":"styles_footer__3f6DM"};